import type { FC } from 'react'
import { useCallback } from 'react'
import type { ActionMenuItem } from '../../components/actions-menu'
import { ActionsMenu } from '../../components/actions-menu'

export enum AgentPromptActionKind {
    Edit = 'edit',
    Assign = 'assign',
    Promote = 'promote',
    Delete = 'delete',
}

interface AgentPromptActionsModalProps {
    anchor: HTMLElement
    promptId: string
    isDefault: boolean
    onClose(): void
    onAction(promptId: string, kind: AgentPromptActionKind): void
}

export const AgentPromptActionsModal: FC<AgentPromptActionsModalProps> = ({
    anchor,
    promptId,
    isDefault,
    onClose,
    onAction,
}) => {
    const _onAction = useCallback(
        (item: ActionMenuItem) => {
            onAction(promptId, item.id as AgentPromptActionKind)
        },
        [onAction, promptId],
    )

    const items: ActionMenuItem[] = [
        { id: AgentPromptActionKind.Edit, name: 'Edit prompt' },
        { id: AgentPromptActionKind.Assign, name: 'Assign organizations…' },
    ]

    // The default is neither promoted again nor deleted: promoting it is a
    // no-op, and deleting it is refused by the API with a 409.
    if (!isDefault) {
        items.push({
            id: AgentPromptActionKind.Promote,
            name: 'Promote to default',
            shouldConfirm: true,
        })
        items.push({
            id: AgentPromptActionKind.Delete,
            name: 'Delete prompt',
            shouldConfirm: true,
        })
    }

    return (
        <ActionsMenu
            anchor={anchor}
            items={items}
            onAction={_onAction}
            onClose={onClose}
        />
    )
}
